import React, { useState, useEffect } from "react";
import axios from "axios";
import { baseurl, imageUrl } from "../Baseurl";
import noproduct from "../component/img/product_not_found.jpeg";
import { Link } from "react-router-dom";

const BlogFilter = ({ slug }) => {
  const [blogs, setBlogs] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");

  useEffect(() => {
    axios
      .get(`${baseurl}GetAllBlogsPublish`)
      .then((res) => {
        setBlogs(res.data);
      })
      .catch((err) => {
        console.error("Error fetching blogs:", err);
      });
  }, []);

  const filteredBlogs = blogs
    .filter((blog) => blog.slug !== slug) // Exclude current blog
    .filter((blog) =>
      blog.title.toLowerCase().includes(searchQuery.toLowerCase())
    );

  return (
    <>
      <div className="  p-4   blog-sidebar">
        {/* <div className="mb-4">
          <input
            type="text"
            className="form-control"
            placeholder="Search blogs by title..."
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
          />
        </div> */}
        <div class="search-box">
          <input
            type="text"
            placeholder="Search..."
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
          />
          <button>SEARCH</button>
        </div>

<div className="recent-articles text-start">
              <h3 className="recent-title">Recent Articles</h3>
              <div className="recent-divider"></div>
</div>
 


        {filteredBlogs.length === 0 ? (
          <div className="text-center">
            <img
              src={noproduct}
              alt="No blogs found"
              style={{ width: "250px" }}
            />
            <p className="mt-2 text-muted">
              No blogs found matching your search.
            </p>
          </div>
        ) : (
          <div className="row g-3">
            {filteredBlogs.map((blog) => (
              <div key={blog.id} className="col-md-12">
                <div class="blog-card">
                  <div class="image-wrapper">
                    <img
                      src={
                        blog.thumbnail
                          ? `${imageUrl}blog/${blog.thumbnail}`
                          : noproduct
                      }
                      alt={blog.alt_img || blog.title}
                    />
                    <span class="date-badge">
                      {new Date(blog.published_at).toLocaleDateString()}
                    </span>
                  </div>
                  <div class="card-content">
                    <Link to={`/blog/${blog.slug}`} data-discover="true">
                      <h3>{blog.title}</h3>
                    </Link>
                    <Link
                      class="read-more"
                      to={`/blog/${blog.slug}`}
                      data-discover="true"
                    >
                      READ MORE <span>↗</span>
                    </Link>
                  </div>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </>
  );
};

export default BlogFilter;
